import React from 'react';
// import ReactDOM from 'react-dom';
import 'antd-mobile/dist/antd-mobile.css';
import '../../index.css';
import intl from 'react-intl-universal';

class UserAgreement extends React.Component {
    render() {
        return (
            <div className="body_pad">
                {intl.getHTML('UserAgreement')}
            </div>
        );
    }
}

export default UserAgreement